import { toast } from "react-toastify";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { __API_URL__ } from "../../SERVER_URL";

const AddDrug = ({
  addDrug,
  setAddDrug,
  setMessage,
  setTypeOfMessage,
  trial,
  GetDrugKitsAPI,
  newDrug,
  setNewDrug,
  setDeleteObjid,
  manual_drug,
  trialDetailApi,
}) => {
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewDrug((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setAddDrug(false);
    setDeleteObjid(0);
  };

  const CreateNewDrug = (e) => {
    e.preventDefault();
    axios
      .post(
        `${__API_URL__}/api/add_drug/`,
        { ...newDrug, trial },
        { headers: { Authorization: `Token ${token}` } }
      )
      .then(() => {
        setAddDrug(false);
        GetDrugKitsAPI();
        setNewDrug({ is_real_drug: true });
        trialDetailApi();
        toast.success("Drug Created Successfully!");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to create drug");
      });
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add Drug
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={CreateNewDrug}>
        <DialogContent dividers>
          <Stack spacing={2}>
            <TextField
              fullWidth
              label="Name"
              size="small"
              name="name"
              value={newDrug?.name || ""}
              onChange={handleChange}
              placeholder="Enter Name"
              required
            />
            <TextField
              fullWidth
              label="Serial Number"
              size="small"
              name="serial_number"
              value={newDrug?.serial_number || ""}
              onChange={handleChange}
              placeholder="Enter Serial Number"
              required
            />
            <TextField
              fullWidth
              label="Units/Dosage"
              size="small"
              name="dosage"
              value={newDrug?.dosage || ""}
              onChange={handleChange}
              placeholder="Enter Units/Dosage"
              required
            />
            <RadioGroup
              row
              value={newDrug.is_real_drug ? "real" : "fake"}
              onChange={(e) =>
                setNewDrug((prev) => ({
                  ...prev,
                  is_real_drug: e.target.value === "real",
                }))
              }
            >
              <FormControlLabel value="real" control={<Radio />} label="Real Drug" />
              <FormControlLabel value="fake" control={<Radio />} label="Fake Drug" />
            </RadioGroup>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddDrug;
